import { IChain, IModel } from "makerjs";
import { ValidatorInterface } from "./ValidatorInterface";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import {
	GeneratedDrillHoleDecorator,
} from "@/utilities/decorators/PreviewModelDecorator";
import EdgeDrillHoles from "@/Models/EdgeDrillHoles";
import GridDrillHoles from "@/Models/GridDrillHoles";
import RadialDrillHoles from "@/Models/RadialDrillHoles";
import PresetDrillHoles from "@/Models/PresetDrillHoles";
import { AbstractValidator, ValidatorObject } from "./AbstractValidator";

export class DrillholeNoEffectValidator extends AbstractValidator implements ValidatorInterface {

	constructor(
		private baseModel: IModel,
		private drillHoleInstance: EdgeDrillHoles | GridDrillHoles | RadialDrillHoles | PresetDrillHoles | null,
		options: ValidatorObject
	) {
		super(options);
	}

	getMessage(): string {
		const { drillHole: drillHoleValidatorMessages } =
			window.measurementSelectorVariables.i18n.validators;

		return (
			drillHoleValidatorMessages.incorrect ??
			"Drillhole is incorrect. Please check the settings"
		);
	}

	isValid(): boolean {
		const baseModel = makerjs.model.clone(this.baseModel);
		const compareModel = makerjs.model.clone(baseModel);
		const modelDecorator = new GeneratedDrillHoleDecorator(null, this.drillHoleInstance);
		let isValid = true;

		const originalModel = modelDecorator.getModel();
		const drillHoleModel = makerjs.model.clone(originalModel);

		const newModel = makerjs.model.combineSubtraction(
			compareModel,
			drillHoleModel
		);

		makerjs.model.zero(newModel);
		makerjs.model.originate(newModel);

		const newModelChains = makerjs.model.findChains(newModel) as IChain[];
		const compareModelChains = makerjs.model.findChains(compareModel) as IChain[];

		// Possible invalid because the number of chains is the same, so the drillhole has no effect
		if (newModelChains.length === compareModelChains.length) {
			isValid = false;

			for (const chain of newModelChains) {
				const chainIndex = newModelChains.indexOf(chain);

				// If the path length is different, then the drillhole has an effect
				if (chain.pathLength !== compareModelChains[chainIndex].pathLength) {
					isValid = true;
				}
			}
		} else {
			isValid = true;
		}

		return isValid;
	}
}
